'use client';

import { cn } from '../lib/utils';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';

const ALL = '__all';

interface FilterSelectProps {
  /** Accessible name of the trigger, e.g. "Client". */
  label: string;
  /** Text shown when nothing is chosen, e.g. "All clients". */
  allLabel: string;
  value: string | null;
  options: ReadonlyArray<{ value: string; label: string }>;
  onChange: (value: string | null) => void;
  className?: string;
}

/** Pill-shaped single-choice filter that sits in a row with `FilterChip`; violet while a value is chosen. */
export function FilterSelect({ label, allLabel, value, options, onChange, className }: FilterSelectProps) {
  return (
    <Select value={value ?? ALL} onValueChange={(v) => onChange(v === ALL ? null : v)}>
      <SelectTrigger
        aria-label={label}
        data-active={value ? '' : undefined}
        className={cn(
          'h-8 w-auto max-w-full gap-1.5 rounded-full px-3 text-xs [&>svg]:size-3.5',
          value
            ? 'border-[var(--l3-violet)] bg-[var(--l3-violet-soft)] text-[var(--l3-violet)]'
            : 'bg-card',
          className,
        )}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{allLabel}</SelectItem>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export type { FilterSelectProps };
